import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { pxToRem } from '../../styles/utils';
import { Box } from '../Box';

export const PhoneNumberWrapper = styled(Box)`
  max-width: ${pxToRem(270)};
  min-width: ${pxToRem(220)};
  height: ${pxToRem(36)};

  ${mediaQueries.tablet} {
    min-width: ${pxToRem(254)};
    max-width: ${pxToRem(270)};
    height: ${pxToRem(40)};
  }
  ${mediaQueries.desktop} {
    min-width: ${pxToRem(260)};
    max-width: ${pxToRem(390)};
    height: ${pxToRem(40)};
  }
`;
